// extracted by mini-css-extract-plugin
module.exports = {"savedButton":"styles_savedButton__XSM91","icon":"styles_icon___ys_K"};
module.exports.__checksum = "65297629a7d7"